import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames/bind";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { getBoard } from "src/utils/Firebase";
import { setBoardId } from "src/redux/board/actions";
import { setMeta } from "src/redux/meta/actions";

import headerImg from "./assets/BoardDetail_test2.jpeg";
import BoardContent from "./components/BoardContent";
import css from "./index.scss";

const cx = classnames.bind(css);
const moduleName = "Boards";
const PAGE_SIZE = 6;

const BoardHeader = () => (
  <div className={cx(`${moduleName}-header`)}>
    <img src={headerImg} alt="boards header" className={cx(`${moduleName}-header-image`)} />
    <div className={cx(`${moduleName}-header-wrapper`)} />
    <div className={cx(`${moduleName}-header-content`)}>
      <p className={cx(`${moduleName}-header-label`)}>Memories</p>
      <h2>추억만들기</h2>
      <h4>소중한 순간들을 함께 나눠요</h4>
    </div>
  </div>
);

const Boards = () => {
  const password = window.localStorage.getItem("passwordForSignIn");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const sentinelRef = useRef(null);
  const loadingRef = useRef(false);
  const hasMoreRef = useRef(true);
  const oldestIdRef = useRef(null);

  const loadMore = () => {
    if (loadingRef.current || !hasMoreRef.current) return;
    loadingRef.current = true;
    setLoading(true);

    let query = getBoard().orderByChild("id").limitToLast(PAGE_SIZE);
    if (oldestIdRef.current !== null) {
      query = getBoard()
        .orderByChild("id")
        .endAt(oldestIdRef.current - 1)
        .limitToLast(PAGE_SIZE);
    }

    query.once("value").then((snap) => {
      const val = snap.val();
      if (!val) {
        hasMoreRef.current = false;
        setHasMore(false);
        loadingRef.current = false;
        setLoading(false);
        return;
      }
      const newItems = Object.values(val).sort((a, b) => b.id - a.id);
      if (newItems.length < PAGE_SIZE) {
        hasMoreRef.current = false;
        setHasMore(false);
      }
      oldestIdRef.current = newItems[newItems.length - 1].id;
      setItems((prev) => {
        const existingIds = new Set(prev.map((i) => i.id));
        return [...prev, ...newItems.filter((i) => !existingIds.has(i.id))];
      });
      loadingRef.current = false;
      setLoading(false);
    });
  };

  // 초기 로드
  useEffect(() => {
    new Image().src = headerImg;
    loadMore();
  }, []);

  // IntersectionObserver
  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) loadMore();
      },
      { rootMargin: "200px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={cx(moduleName)}>
      <BoardHeader />

      <div className={cx(`${moduleName}-toolbar`)}>
        {password && (
          <Link to="/board/new" className={cx(`${moduleName}-new-btn`)}>
            + 새 글 작성
          </Link>
        )}
      </div>

      <div className={cx(`${moduleName}-feed`)}>
        {items.map((value) => (
          <BoardContent
            key={value.id}
            boardId={value.id}
            title={value.title}
            content={value.content}
            date={value.date}
            imgUrl={value.imgUrl && value.imgUrl[0] ? value.imgUrl[0] : ""}
          />
        ))}
      </div>

      <div ref={sentinelRef} className={cx(`${moduleName}-sentinel`)}>
        {loading && <div className={cx(`${moduleName}-loading`)}>불러오는 중…</div>}
        {!hasMore && items.length > 0 && (
          <p className={cx(`${moduleName}-end`)}>모든 게시물을 불러왔습니다</p>
        )}
      </div>
    </div>
  );
};

export default connect(
  ({ meta }) => ({ meta }),
  { setBoardId, setMeta }
)(Boards);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Boards/index.js